const exceptDomainSet = new Set([
    "about",
    "admin",
    "administrator",
    "apache",
    "api",
    "app",
    "assets",
    "auth",
    "aws",
    "cdn",
    "cert",
    "certificate",
    "cloudfront",
    "config",
    "contact",
    "create",
    "database",
    "db",
    "delete",
    "deploy",
    "dev",
    "docker",
    "drop",
    "ec2",
    "env",
    "enviroment",
    "firewall",
    "ftp",
    "gateway",
    "git",
    "github",
    "gitlap",
    "help",
    "home",
    "http",
    "https",
    "index",
    "insert",
    "k8s",
    "key",
    "kubernetes",
    "lambda",
    "localhost",
    "login",
    "mail",
    "main",
    "mob",
    "mongo",
    "monitor",
    "monitoring",
    "mysql",
    "nginx",
    "node",
    "npm",
    "page",
    "pass",
    "passwd",
    "password",
    "postgre",
    "privacy",
    "prod",
    "production",
    "proxy",
    "qw1k",
    "qwik",
    "react",
    "rds",
    "redis",
    "register",
    "root",
    "s3",
    "sample",
    "secret",
    "secure",
    "security",
    "select",
    "settings",
    "signin",
    "signup",
    "site",
    "ssh",
    "ssl",
    "stage",
    "staging",
    "static",
    "sudo",
    "superuser",
    "support",
    "tcp",
    "terms",
    "test",
    "tls",
    "token",
    "udp",
    "update",
    "upload",
    "user",
    "vpn",
    "vue",
    "web",
    "www"
]);

export default exceptDomainSet;